import { render, staticRenderFns } from "./InfoScholarship.vue?vue&type=template&id=473bc127&"
import script from "./InfoScholarship.vue?vue&type=script&lang=js&"
export * from "./InfoScholarship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports